export default {
  'House Tours': {
    Watch: {
      id: '2',
      data: {
        title: 'Watch'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '2-1',
          type: 'teaser',
          data: {
            headline: 'Tiny Tours',
            url:
              'https://video.apartmenttherapy.com/m/Hl9nO6g7/a-275-square-foot-apartment-tiny-tours?list=L4MnN1Xd'
          }
        },
        {
          id: '2-2',
          type: 'teaser',
          data: {
            headline: 'The New Homesmiths',
            url:
              'https://video.apartmenttherapy.com/m/BuS1JMcy/the-new-homesmiths-i-live-in-a-tiny-house?list=qNS9ehmg'
          }
        },
        {
          id: '2-3',
          type: 'teaser',
          data: {
            headline: 'Video House Tours',
            url:
              'https://video.apartmenttherapy.com/m/dNAoLuHp/marikas-gathering-friendly-loft-house-tour?list=1xVOF6uQ'
          }
        }
      ]
    }
  },
  Style: {
    Watch: {
      id: '4',
      data: {
        title: 'Watch'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '4-1',
          type: 'teaser',
          data: {
            headline: 'The Couch',
            url:
              'https://video.apartmenttherapy.com/m/XZQGhgUw/nate-berkus-and-jeremiah-brent-the-couch?list=kX3gh4xk'
          }
        },
        {
          id: '4-2',
          type: 'teaser',
          data: {
            headline: '$32 Design Challenge',
            url:
              'https://video.apartmenttherapy.com/m/iESMqEfh/a-stylish-and-functional-entryway-transformation?list=lzsAQrFw'
          }
        },
        {
          id: '4-3',
          type: 'teaser',
          data: {
            headline: 'Apartment Makeover Takeover',
            url:
              'https://video.apartmenttherapy.com/m/FQJLK8nD/terris-scandi-vintage-studio-makeover-instagram-apartment-takeover'
          }
        }
      ]
    }
  },
  'How To': {
    Watch: {
      id: '5',
      data: {
        title: 'Watch'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '5-1',
          type: 'teaser',
          data: {
            headline: 'How to Paint a Door',
            url:
              'https://video.apartmenttherapy.com/m/OvnBymEN/how-to-paint-a-door'
          }
        },
        {
          id: '5-2',
          type: 'teaser',
          data: {
            headline: 'How to Paint a Wall',
            url:
              'https://video.apartmenttherapy.com/m/ro0jsKw7/how-to-paint-a-wall'
          }
        },
        {
          id: '5-3',
          type: 'teaser',
          data: {
            headline: 'The Plant Doctor With Hilton Carter',
            url:
              'https://video.apartmenttherapy.com/m/jCOXEaYH/your-ultimate-fiddle-leaf-fig-guide-the-plant-doctor?list=O6HaUZTk'
          }
        }
      ]
    }
  },
  'Organize & Clean': {
    Watch: {
      id: '8',
      data: {
        title: 'Watch'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '8-1',
          type: 'teaser',
          data: {
            headline: 'Taryn Cleans It All',
            url:
              'https://video.apartmenttherapy.com/m/wynGyzXD/how-to-declutter-your-closet?list=2rCdl2Ck'
          }
        },
        {
          id: '8-2',
          type: 'teaser',
          data: {
            headline: 'Organizing Zen',
            url:
              'https://video.apartmenttherapy.com/m/lbDjRWM3/organizing-zen-conquering-the-mystery-closet?list=DsMldQM9'
          }
        },
        {
          id: '8-3',
          type: 'teaser',
          data: {
            headline: 'Advice From Marie Kondo',
            url:
              'https://video.apartmenttherapy.com/m/okMNIgOr/pack-a-suitcase-with-marie-kondo?list=nScgzcjH'
          }
        }
      ]
    }
  },
  Living: {
    Trending: {
      id: '9',
      data: {
        title: 'Trending'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '9-1',
          type: 'teaser',
          data: {
            headline: 'The Best Party Games',
            url:
              'https://www.apartmenttherapy.com/10-always-entertaining-party-games-131753'
          }
        },
        {
          id: '9-2',
          type: 'teaser',
          data: {
            headline:
              '50 Cities Where You Can Actually Afford to Live Alone on a $45K Salary',
            url:
              'https://www.apartmenttherapy.com/how-much-rent-can-i-afford-45k-affordable-cities-36664024'
          }
        },
        {
          id: '9-3',
          type: 'teaser',
          data: {
            headline:
              'Co-Living Is Not a Trend, It’s How Everyone Has to Live Now',
            url:
              'https://www.apartmenttherapy.com/coliving-economy-explained-36663287'
          }
        }
      ]
    },
    Watch: {
      id: '10',
      data: {
        title: 'Watch'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '10-1',
          type: 'teaser',
          data: {
            headline: 'Liz$plaining',
            url:
              'https://video.apartmenttherapy.com/m/6gDUXN6G/lizplaining-the-unexpected-costs-of-buying-a-home?list=aF5j9XBY'
          }
        },
        {
          id: '10-2',
          type: 'teaser',
          data: {
            headline: 'The Couch',
            url:
              'https://video.apartmenttherapy.com/m/XZQGhgUw/nate-berkus-and-jeremiah-brent-the-couch?list=kX3gh4xk'
          }
        },
        {
          id: '10-3',
          type: 'teaser',
          data: {
            headline: '9 Habits for a Happy Home',
            url:
              'https://video.apartmenttherapy.com/m/gzS2jW2h/9-habits-for-a-happier-home?list=2MSvStVX'
          }
        }
      ]
    }
  },
  Shop: {
    'Shopping Guides': {
      id: '11',
      data: {
        title: 'Shopping Guides'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '11-1',
          type: 'teaser',
          data: {
            headline: 'Gifting Therapy',
            url: 'https://www.apartmenttherapy.com/features/gift-guide-2019'
          }
        },
        {
          id: '11-2',
          type: 'teaser',
          data: {
            headline: 'The Best List',
            url: 'https://www.apartmenttherapy.com/collection/the-best-list'
          }
        },
        {
          id: '11-3',
          type: 'teaser',
          data: {
            headline: '101 Places to Shop Online',
            url:
              'https://www.apartmenttherapy.com/101-places-to-buy-furniture-amp-home-decor-online-237380'
          }
        }
      ]
    },
    'Top Shopping Posts': {
      id: '12',
      data: {
        title: 'Top Shopping Posts'
      },
      variant: 'navTextLink',
      items: [
        {
          id: '12-1',
          type: 'teaser',
          data: {
            headline:
              'The Surprising Place to Shop for Scandinavian-Style Furniture (No, It’s Not IKEA)',
            url:
              'https://www.apartmenttherapy.com/affordable-scandinavian-style-furniture-36660134'
          }
        },
        {
          id: '12-2',
          type: 'teaser',
          data: {
            headline:
              'The $13 Shower Curtain Amazon Reviewers Can’t Stop Gushing About',
            url:
              'https://www.apartmenttherapy.com/best-shower-curtain-amazon-review-36654686'
          }
        },
        {
          id: '12-3',
          type: 'teaser',
          data: {
            headline:
              'Joss & Main Just Released Their Most-Loved Pieces of 2019—and They’re All On Sale',
            url:
              'https://www.apartmenttherapy.com/joss-and-main-best-sellers-36658819'
          }
        }
      ]
    }
  }
};
